<template>
  <div>
    <HeadlineContainer headline="Content" :breadcrumbs="[{text: 'Content'}]"/>

    <div class="container">
      <ContentPortalList/>
    </div>
  </div>
</template>

<script>
import ContentPortalList from '../../../components/Content/ContentPortals/Panels/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'

export default {
  components: {ContentPortalList, HeadlineContainer},
}
</script>
